/**
 * rb-export-text.js — plain-text and JSON exports + the shared download
 * helper and a lazy script loader used by the other exporters.
 *
 * Depends on: RbState, RbI18n.
 * globalThis.RbExportText
 */
(function () {
    'use strict';

    var T = function (k) { return globalThis.RbI18n.t(k); };
    var _m = null;
    var D = function (k) { return globalThis.RbI18n.docT ? globalThis.RbI18n.docT(k, _m) : T(k); };

    /* «Анна_Смирнова_Резюме.pdf» — the person's name and the word for the document */
    function safeName(model, ext) {
        var clean = function (s) { return String(s || '').replace(/[^\p{L}\p{N}\s-]/gu, '').trim().replace(/\s+/g, '_'); };
        var word = clean(T('file_word')) || 'Resume';
        var n = clean(model.personal && model.personal.name);
        return (n ? n + '_' + word : word) + '.' + ext;
    }

    /* The site's download door: a raw <a download href=blob:> is a silent no-op in
       Android WebViews. Resolves true/false — whether the file was handed over. */
    function download(blob, filename) {
        if (typeof window !== 'undefined' && window.__downloadFile) return Promise.resolve(window.__downloadFile(blob, filename));
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = filename;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
        return Promise.resolve(true);
    }

    /* lazy <script> loader: tries each src in order, resolves on first load */
    var _loaded = {};
    function loadScript() {
        var srcs = Array.prototype.slice.call(arguments);
        var key = srcs[0];
        if (_loaded[key]) return Promise.resolve();
        return srcs.reduce(function (chain, src) {
            return chain.catch(function () {
                return new Promise(function (resolve, reject) {
                    var s = document.createElement('script');
                    s.src = src;
                    s.onload = function () { _loaded[key] = true; resolve(); };
                    s.onerror = reject;
                    document.head.appendChild(s);
                });
            });
        }, Promise.reject()).catch(function () {
            throw new Error('script load failed: ' + key);
        });
    }

    /* Vendor-lib source list: local /vendor/ copy first, CDN fallback second.
       The blade injects window.__rbVendor with the CDN fallback resolved
       through cdn() (RU users get the /cdn/ reverse-proxy on the RU VPS, so a
       blocked external host is never contacted directly). Hardcoded defaults
       cover the case the page didn't inject it (e.g. node tests). */
    var VENDOR_DEFAULT = {
        docx: ['/vendor/docx/index.umd.min.js', 'https://cdn.jsdelivr.net/npm/docx@8.5.0/build/index.umd.min.js'],
        jspdf: ['/vendor/jspdf/jspdf.umd.min.js', 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js'],
        html2canvas: ['/vendor/html2canvas/html2canvas.min.js', 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'],
        qrcode: ['/vendor/qrcode/qrcode.min.js', 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js'],
        mammoth: ['/vendor/mammoth/mammoth.browser.min.js', 'https://cdn.jsdelivr.net/npm/mammoth@1.8.0/mammoth.browser.min.js']
    };
    function vendorSrcs(name) {
        var v = globalThis.__rbVendor && globalThis.__rbVendor[name];
        return (v && v.length) ? v.slice() : (VENDOR_DEFAULT[name] || []).slice();
    }
    /* lazy-load a vendor lib by name (docx | jspdf | html2canvas) */
    function loadVendor(name) {
        return loadScript.apply(null, vendorSrcs(name));
    }

    /* ---- TXT — clean ATS-plain text dump ------------------------------- */
    function buildText(model) {
        _m = model;
        var L = [];
        var p = model.personal || {};
        if (p.name) L.push(p.name);
        if (p.title) L.push(p.title);
        var contact = ['email', 'phone', 'city', 'address', 'website', 'linkedin', 'github']
            .map(function (k) { return p[k]; }).filter(Boolean);
        if (contact.length) L.push(contact.join('  |  '));
        if (globalThis.RbRender && globalThis.RbRender.prefPairs) {
            globalThis.RbRender.prefPairs(model).forEach(function (pp) { L.push(pp[0] + ': ' + pp[1]); });
        }
        L.push('');

        function heading(key) { L.push(''); L.push(D('section_' + key).toUpperCase()); L.push(''); }

        (model.meta.sectionOrder || []).forEach(function (sec) {
            if (sec === 'personal') return;
            if (sec === 'summary') {
                if (model.summary) { heading('summary'); L.push(model.summary); }
                return;
            }
            var items = model[sec] || [];
            if (!items.length) return;
            heading(sec);
            items.forEach(function (x) {
                if (sec === 'experience') {
                    L.push(x.position + (x.company ? ' — ' + x.company : '') +
                        (x.location ? ', ' + x.location : ''));
                    L.push([x.startDate, x.current ? D('present') : x.endDate].filter(Boolean).join(' - '));
                    if (x.description) L.push(x.description);
                    String(x.achievements || '').split('\n').filter(Boolean).forEach(function (a) {
                        L.push('  - ' + a.trim());
                    });
                } else if (sec === 'education') {
                    L.push([x.degree, x.field].filter(Boolean).join(', ') + (x.institution ? ' — ' + x.institution : ''));
                    L.push([x.startDate, x.endDate].filter(Boolean).join(' - '));
                } else if (sec === 'skills') {
                    /* one combined line below */
                } else {
                    var vals = Object.keys(x).filter(function (k) { return k !== 'id' && x[k]; })
                        .map(function (k) { return x[k]; });
                    L.push(vals.join(' — '));
                }
                if (sec !== 'skills') L.push('');
            });
            if (sec === 'skills') {
                L.push(items.map(function (s) { return s.name; }).join(', '));
            }
        });
        (model.custom || []).forEach(function (cs) {
            if (!cs.title && !(cs.items || []).some(Boolean)) return;
            L.push(''); L.push((cs.title || '').toUpperCase()); L.push('');
            (cs.items || []).filter(Boolean).forEach(function (i) { L.push(i); });
        });
        return L.join('\n').replace(/\n{3,}/g, '\n\n');
    }

    function exportTxt(model) {
        return download(new Blob([buildText(model)], { type: 'text/plain;charset=utf-8' }), safeName(model, 'txt'));
    }

    function exportJson(model) {
        return download(new Blob([JSON.stringify(model, null, 2)], { type: 'application/json' }), safeName(model, 'json'));
    }

    globalThis.RbExportText = {
        safeName: safeName,
        download: download,
        loadScript: loadScript,
        vendorSrcs: vendorSrcs,
        loadVendor: loadVendor,
        buildText: buildText,
        exportTxt: exportTxt,
        exportJson: exportJson
    };
})();
